import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
} from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconArrowBigDownFilled,
  IconArrowBigUpFilled,
  IconCircleMinus,
  IconExchange,
} from "@tabler/icons-react";

export const BTC_BALANCE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Your BTC balance is the amount of "on-chain" funds that you have in your
      Rizful node.
    </p>
    <p>
      On-chain funds are transactions written to Bitcoin's blockchain, and to
      send or receive an on-chain payment, you need to wait for a new block to
      appear on the blockchain.
    </p>

    <p>
      Bitcoin blocks only confirm about once every ten minutes, and, you need to
      pay fees to get your transactions included in a block.
    </p>

    <p>So: "on-chain" payments can be really slow, and sometimes expensive.</p>
    <p>
      Actually the fact that on-chain transactions can be both{" "}
      <strong>slow</strong> and <strong>costly</strong>... is reason that the
      Lightning Network was invented in the first place!
    </p>

    <DocsHighlightCard>
      <Title order={4}>
        Actions that will change your BTC balance include...
      </Title>

      <p>Depositing BTC: </p>
      <DocsButton
        ariaLabel="deposit btc"
        text="Deposit BTC"
        leftSection={<IconArrowBigDownFilled />}
      />

      <p>Withdrawing BTC:</p>
      <DocsButton
        ariaLabel="withdraw btc"
        text="Withdraw BTC"
        leftSection={<IconArrowBigUpFilled />}
      />

      <p>Closing a Lightning channel:</p>
      <DocsButton
        ariaLabel="close channel"
        text="Close Channel"
        leftSection={<IconCircleMinus stroke={1.5} />}
      />

      <p>Opening a Lightning channel:</p>
      <DocsButton
        ariaLabel="open channel to peer"
        text="Open Channel"
        leftSection={<IconExchange />}
      />
    </DocsHighlightCard>
  </TypographyStylesProvider>
);
